// @flow
import type { ModalType } from 'containers/ModalRoot';
import type { Action } from '../actions/modal';

const initialState = {
  type: null,
  props: {}
};

export type State = {
  type: ?ModalType,
  props: Object
};

export default function modal(state: State = initialState, action: Action) {
  switch (action.type) {
    case 'MODAL_SHOW':
      return {
        ...state,
        type: action.payload.type,
        props: action.payload.props
      };
    case 'MODAL_HIDE':
      return initialState;
    default:
      return state;
  }
}
